import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";

import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ProfileComponent from "../../ChurchMemberPages/Dashboard/ProfileComponent";
import ContextMenuSection from "../../ChurchMemberPages/Dashboard/ContextMenuSection";
import Modal from "../../../components/Modal/Modal";
import BankPaymentPage from "./BankPaymentPage";
import { HiOutlineCash, HiOutlineCalendar, HiOutlineCreditCard, HiOutlineUser, HiArrowLeft, HiOutlineDocument, HiOutlineClock } from 'react-icons/hi';

const MemberPaymentChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  const currentDt = new Date();
  const year = currentDt.getFullYear();
  const month = (currentDt.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDt.getDate().toString().padStart(2, "0");
  const random =
    year +
    month +
    day +
    Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, "0");

  //Error Logging Service & Santize Input
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [churchMembers, setChurchMembers] = useState(null);
  const [monthlySubrptn, setMonthlySubs] = useState(0);
  const [paidUpto, setPaidUpto] = useState(0);
  const [outstandingMonth, setOutstandingMonth] = useState(0);
  const [outstandingAmt, setOutstandingAmt] = useState(0);
  const [paymentMonth, setPaymentMonth] = useState(0);
  const [formData, setFormData] = useState({
    financial_year: user?.current_financial_year
      ? user?.current_financial_year
      : null,
    receipt_no: random,
    receipt_date: null,
    subscriber_id: null,
    monthly_subscription: null,
    paid_up_to: null,
    outstanding_months: null,
    outstanding_amount: null,
    payment_amount: null,
    payment_month: null,
    payment_mode: null,
    payment_status: null,
    transaction_receipt: null,
  });
  // Get the current year
  const currentDate = new Date(); // Get the current date
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const generateFinancialYears = () => {
    const years = [];
    for (
      let year = currentYear;
      year > currentYear - (currentYear - previousYear);
      year--
    ) {
      years.push({
        value: year + "-" + (year + 1),
        label: year + "-" + (year + 1),
      });
    }
    return years;
  };

  const financialYears = generateFinancialYears();
  //console.log(financialYears[0].value);

  //toggle modal
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/subscriber/church/${user.church_id}`;
    const config = {
      method: "get",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      // data: { ...formData },
    };

    axios(config)
      .then(function (response) {
        const members = response.data.subscribers;
        //   console.log(members);
        const fileterData = members.filter(
          (dta) => dta?.subscriber_id?._id === user?._id
        );
        setChurchMembers(
          fileterData.map((member) => ({
            value:
              member.subscriber_id._id +
              "#_#" +
              member.monthly_subscription +
              "#_#" +
              member.date_of_joining,
            label:
              member.subscriber_id.first_name +
              " " +
              member.subscriber_id.last_name +
              " (" +
              member.subscriber_id.user_type +
              ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "member/outstanding", "/member/online payment");
      });
  }, []);

  useEffect(() => {
    let data = {};
    if (churchMembers) {
      let data = { value: churchMembers[0]?.value };
      handleDropdownChange(data);
    }
  }, [churchMembers]);
  const handleChange = ({ currentTarget: input }) => {
    if (input.name === "payment_amount") {
      let total_mnth = input.value / monthlySubrptn;
      let enterVal = input.value;
      if (parseInt(enterVal) > parseInt(monthlySubrptn)) {
        if (!Number.isInteger(total_mnth)) {
          setPaymentMonth(0);
          toast.error("Please enter multiples of monthly subscription");
          return;
        }
      }
      setPaymentMonth(total_mnth);
    }
    setFormData({
      ...formData,
      [input.name]: input.value,
      payment_month: paymentMonth,
      monthly_subscription: monthlySubrptn,
      paid_up_to: paidUpto,
      outstanding_months: outstandingMonth,
      outstanding_amount: outstandingAmt,
    });
  };
  const handleDropdownChange = (event) => {
    let subIdArr = event.value.split("#_#");
    setMonthlySubs(subIdArr[1]);
    let startDate = subIdArr[2];
    let endDate = currentDate;

    setPaidUpto(startDate);
    // **************check last payment date***************
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/receipt/last_payment/${subIdArr[0]}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const newData = response.data.receipts;
        // console.log(newData.payment_date);
        setPaidUpto(subIdArr[2]);
        let startDate = null;
        //console.log(JSON.stringify(newData?.payment_date));
        if (newData?.payment_date) {
          const newDate = new Date(moment(newData.payment_date));
          newDate.setMonth(newDate.getMonth() + 1);
          setPaidUpto(newDate);
          startDate = newDate;
        }
        // console.log(JSON.stringify(startDate + "   " + endDate));
        if (startDate && endDate) {
          const start = new Date(startDate);
          const end = new Date(endDate);
          const months =
            (end.getFullYear() - start.getFullYear()) * 12 +
            (end.getMonth() - start.getMonth());
          //console.log(months);
          setOutstandingMonth(months);
          setOutstandingAmt(months * subIdArr[1]);
        }
      })
      .catch(function (err) {
        console.log("error occured.");
      });
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const months =
        (end.getFullYear() - start.getFullYear()) * 12 +
        (end.getMonth() - start.getMonth());
      setOutstandingMonth(months);
      setOutstandingAmt(months * subIdArr[1]);
    }
    setFormData({
      ...formData,
      subscriber_id: event.value,
      receipt_date: currentDate,
    });
  };
  const handleOnlinePayment = (e) => {
    if (!formData.subscriber_id) return toast.error("Select the Subscriber");

    if (!formData.financial_year)
      return toast.error(
        "Financial year not resolved. Kindly check with Church Admin."
      );

    if (!formData.payment_amount)
      return toast.error("Please enter payment amount");

    if (
      parseInt(formData.payment_amount) <
      parseInt(formData.monthly_subscription)
    )
      return toast.error("Please enter multiples of monthly subscription");

    if (formData.payment_month === "0")
      return toast.error("Please enter multiples of monthly subscription");

    //   if (!formData.payment_mode)
    //     return toast.error("Please select payment mode");

    //   if (!formData.payment_status)
    //     return toast.error("Please select payment status");

    if (
      parseInt(formData.payment_amount) > parseInt(formData?.outstanding_amount)
    ) {
      return toast.error("The amount should be equal to outstanding");
    }

    //Open Modal
    setShowModal(true);
    //completePaymentTransaction();
  };

  const completePaymentTransaction = (receipt) => {
    let userToken = localStorage.getItem("token");

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/receipt/add`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: {
        ...formData,
        payment_mode: "5",
        payment_status: "0",
        transaction_receipt: receipt,
      },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success(
          "Payment created Successfully. Your transaction id is " +
            formData?.receipt_no
        );
        navigate("/member/payments");
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(error?.response?.data?.error);
        errorLogApi(error, "SubscriberAddChild", "/subscriber/add");
        // console.log(error);
      });
  };

  const inputElementWidthStyle = `w-10/12 p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md outline-none`;

  const incomeSourceOptions = [
    { value: 1, label: "Cash" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "Online Transfer" },
    { value: 4, label: "Demand Draft" },
  ];

  const paymentStatusOption = [
    { value: 0, label: "Pending" },
    { value: 1, label: "Settled" },
    { value: 2, label: "Declined" },
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      payment_month: paymentMonth,
      financial_year: user?.current_financial_year,
    });
  }, [paymentMonth]);

  return (
    <div className="w-full">
      {showModal && (
        <Modal onClose={toggleModal}>
          <BankPaymentPage
            church_id={user.church_id}
            amount={formData?.payment_amount}
            completePaymentTransaction={completePaymentTransaction}
          />
        </Modal>
      )}
      <div className="flex flex-grow bg-gray-100">
        <div className="flex flex-grow bg-gray-100">
          <div className="w-full md:block">
            <div className="overflow-y-hidden top-0 md:h-screen">
              <CardBackground>
                <div className="max-w-5xl mx-auto">
                  <div className="p-6">
                    {/* Header Section */}
                    <div className="flex items-center justify-between mb-8">
                      <div>
                        <h1 className="text-2xl font-bold text-gray-900">Online Payment</h1>
                        <p className="mt-1 text-sm text-gray-500">Complete your monthly subscription payment</p>
                      </div>
                      <div className="flex space-x-3">
                        <button
                          className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
                          onClick={() => navigate(-1)}
                        >
                          <HiArrowLeft className="w-4 h-4 mr-2" />
                          Back
                        </button>
                        <button
                          className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                          onClick={handleOnlinePayment}
                        >
                          <HiOutlineCreditCard className="w-4 h-4 mr-2" />
                          Make Payment
                        </button>
                      </div>
                    </div>

                    {/* Form Section */}
                    <div className="space-y-6 bg-white rounded-lg border border-gray-200 p-6">
                      {/* Row 1 */}
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Financial Year</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCalendar className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="receipt_no"
                              value={user?.current_financial_year}
                              disabled={true}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Receipt No</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineDocument className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="receipt_no"
                              value={formData.receipt_no}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Receipt Date</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCalendar className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="receipt_date"
                              value={moment(currentDate).format("DD-MM-YYYY")}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 2 */}
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Member</label>
                          <div className="mt-1">
                            <Select
                              name="subscriber_id"
                              onChange={handleDropdownChange}
                              options={churchMembers}
                              placeholder={placeHolderText("Select Member")}
                              className="block w-full"
                              menuPosition={"fixed"}
                              value={churchMembers && churchMembers?.find((c) => c.value === churchMembers[0].value)}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  height: '38px',
                                  minHeight: '38px'
                                })
                              }}
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Monthly Subscription</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCash className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="monthly_subscription"
                              value={monthlySubrptn}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Paid Upto</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineClock className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="paid_up_to"
                              value={moment(paidUpto).format("MMMM, YYYY")}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 3 */}
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Outstanding No of Months</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCalendar className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="outstanding_months"
                              value={outstandingMonth}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Outstanding Amount</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCash className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="outstanding_amount"
                              value={outstandingAmt}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-500 sm:text-sm"
                              readOnly
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">Payment Amount</label>
                          <div className="mt-1 relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <HiOutlineCash className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                              type="text"
                              name="payment_amount"
                              value={formData?.payment_amount}
                              onChange={handleChange}
                              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 4 */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Payment for No of Months</label>
                        <div className="mt-1 relative max-w-xs">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <HiOutlineCalendar className="h-5 w-5 text-gray-400" />
                          </div>
                          <input
                            type="text"
                            name="payment_month"
                            value={paymentMonth}
                            onChange={handleChange}
                            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBackground>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberPaymentChild;
